import './reset.css'
import './fonts.css'
import './index.css'
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import MenuPage from './pages/MenuPage/MenuPage';
import AboutPage from './pages/AboutPage/AboutPage';
import ContactPage from './pages/ContactPage/ContactPage';
import GalleriePage from './pages/GalleriePage/GalleriePage';
import LegalPage from './pages/LegalPage/LegalPage';
import PrivacyPage from './pages/PrivacyPage/PrivacyPage';
import Header from './layouts/Header/Header';
import Footer from './layouts/Footer/Footer';
import ReservationPage from './pages/ReservationPage/ReservationPage';
import LoginPage from './pages/LoginPage/LoginPage';
import DashboardPage from './pages/DashboardPage/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

const queryClient = new QueryClient();

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/login"
            element={<LoginPage />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <>
                <Header />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/menu" element={<MenuPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/gallerie" element={<GalleriePage />} />
                  <Route path="/reservation" element={<ReservationPage />} />
                  <Route path="/mentions-legales" element={<LegalPage />} />
                  <Route path="/politique-confidentialite" element={<PrivacyPage />} />
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
